export const checkShowLogo = (messages, index) => {
  return (
    messages[index].isFromBot &&
    (messages[index + 1]
      ? messages[index].isFromBot && !messages[index + 1].isFromBot
      : messages.length === index + 1 && messages[index].isFromBot)
  )
}

export const defineMessageBorder = (messages, index) => {//NOSONAR
  if (messages[index].isFromBot) {
    const hasPrevReceived = messages[index - 1] && messages[index - 1].isFromBot
    const hasNextReceived = messages[index + 1] && messages[index + 1].isFromBot

    if (
      hasNextReceived &&
      (!messages[index - 1] || !messages[index - 1].isFromBot)
    )
      return '17px 17px 17px 2px'
    if (hasPrevReceived && hasNextReceived) return '2px 17px 17px 2px'
    if (
      hasPrevReceived &&
      (!messages[index + 1] || !messages[index + 1].isFromBot)
    )
      return '2px 17px 17px 17px'
  }

  if (!messages[index].isFromBot) {
    const hasPrevReceived = messages[index - 1] && !messages[index - 1].isFromBot
    const hasNextReceived = messages[index + 1] && !messages[index + 1].isFromBot

    if (
      hasNextReceived &&
      (!messages[index - 1] || messages[index - 1].isFromBot)
    )
      return '17px 17px 2px 17px'
    if (hasPrevReceived && hasNextReceived) return '17px 2px 2px 17px'
    if (
      hasPrevReceived &&
      (!messages[index + 1] || messages[index + 1].isFromBot)
    )
      return '17px 2px 17px 17px'
  }
}

export const defineMessageMargin = (messages, index) => {
  if (!messages[index].isFromBot) {
    const hasPrevReceived = messages[index - 1] && messages[index - 1].isFromBot
    const hasNextReceived = messages[index + 1] && messages[index + 1].isFromBot

    if (hasPrevReceived && hasNextReceived) return '26px 0px 26px 0px'
    if (hasPrevReceived) return '26px 0px 4px 0px'
    if (hasNextReceived) return '4px 0px 26px 0px'
  }
}

export const messageContainerSize = (
  device,
  textEnable,
  isFullScreenWidget,
  scrollBehavior,
) => {
  const marginBottom = 65
  const horizontalMargin = 0
  const chatInputHeightAndPadding = device.height > 0 ? 100 : 0
  const needCustomSize = device.height > 0 || device.width > 0
  const heightWithoutInput = needCustomSize
    ? `${device.height - marginBottom}px`
    : '465px'
  const heightWithInput = needCustomSize
    ? `${device.height - chatInputHeightAndPadding}px`
    : '413px'
  const widgetFullScreenHeight = textEnable
    ? `calc(100% - ${chatInputHeightAndPadding}px)`
    : '100%'

  if (isFullScreenWidget) {
    return {
      height: widgetFullScreenHeight,
      width: needCustomSize ? `${device.width - horizontalMargin}px` : '100%',
      scrollBehavior,
    }
  }

  return {
    height: textEnable ? heightWithInput : heightWithoutInput,
    width: needCustomSize ? `${device.width - horizontalMargin}px` : '100%',
    scrollBehavior,
  }
}

export const chatSize = (height, width, isFullScreenWidget) => {
  const headerHeight = 65

  if (isFullScreenWidget) {
    return {
      height: `calc(100% - ${headerHeight}px)`,
      width: '100%',
    }
  }

  return {
    height: height > 0 ? `${height - headerHeight}px` : 'auto',
    width: width > 0 ? `${width}px` : '100%',
  }
}
